$(document).ready(function () {

	$(".szukaj_img").on("click", function() {
	    $('.szukaj').submit();
	 });

	$('.szukaj_img_mobile').on('click', function() {
		var search = $('.szukaj_input__svg');

		if (search.hasClass('show')) {
			search.removeClass('show');
		}else {
			search.addClass('show');
		}
	})

})